module.exports = __webpack_public_path__ + "static/media/green-leaf.2521fba6.svg";